import React, { useState } from "react";
import Footer from "../../components/Footer_/Footer";
import AboutSec from "../../components/AboutSec_/AboutSec";
import CommonHero from "../../components/CommonHero_/CommonHero";
import { Helmet } from "react-helmet";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Col, Container, Row, Spinner } from "react-bootstrap";
import formstyles from "../InfoScreens/ContactScreen.module.css";
import CallToAction from "../../components/CallToAction/CallToAction";

const Caledon = () => {
   const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [phoneNum, setPhoneNum] = useState("");
    const [message, setMessage] = useState("");
    const [success, setSuccess] = useState(false);
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);
  
    const history = useNavigate();
  
    const formSubmitHandler = (event) => {
      event.preventDefault();
      setLoading(true);
      axios
        .post("/send-contact-form", {
          name,
          email,
          phoneNumber: phoneNum,
          message,
        })
        .then((response) => {
          if (response.data.msg === "success") {
            setError(false);
            setSuccess("Form Submitted Successfully!");
            setLoading(false);
            setEmail("");
            history("/thank-you");
          } else if (response.data.msg === "fail") {
            setSuccess(false);
            setError("Email failed to send, try again by reloading the page.");
            setLoading(false);
            setEmail("");
          }
        });
    };
  return (
    <>
      <Helmet>
        <title>Professional Electrician Services in Caledon | TRU Off Grid</title>
        <meta name="keywords" content="Caledon" />
        <link
          rel="canonical"
          href="https://www.truoffgrid.com/location/caledon"
        />
        <meta
          name="description"
          content="Looking for a licensed electrician in Caledon? TRU Off Grid provides ESA-certified residential & commercial electrical, panel upgrades, & backup power."
        />
      </Helmet>
       <CommonHero
        shopHero={true}
        heading="Professional Electrician Service in Caledon"
      />
     
      <AboutSec
        heading={"Licensed Electricians for Every Project in Caledon"}
        subHeading={""}
        text={`Electrical issues can disrupt your home or business without warning. TRU Electrical Services provides dependable electrician service in Caledon for residential and commercial properties. Backed by a Master Electrician License from the Electrical Safety Authority (ESA), our team delivers safe, code-compliant electrical services in Caledon, including panel upgrades, solar interconnections, backup power systems, and commercial electrical installations.`}
        img={"/images/tru-electrical-servies.png"}
        cta={true}
      />
      <CallToAction cta5={{heading:"Need Reliable Electrical Solutions in Caledon?"}} />
      <AboutSec
        heading={"Reliable Electrical Services for Homes & Businesses in Caledon"}
        subHeading={""}
        text={`TRU Electrical Services provides complete electrical solutions for residential and commercial properties throughout Caledon. As an experienced electrical contractor Caledon property owners trust, we install and upgrade electrical systems, including panel upgrades, dedicated circuits, lighting automation, three-phase power distribution, solar electrical integration, and ESA permitting. We also complete electrical work for home renovations, commercial fit-outs, renewable energy systems, and new construction projects. Whether you need a residential electrician Caledon homeowners rely on or electrical services for your business, every project is done in accordance with current electrical codes and ESA requirements.`}
        img={"/images/eg4-gridboss-at-the-meter.jpg"}
        reverse={true}
        cta={true}
        imgBorderRad={true}
      />
      <AboutSec
        heading={"Keep Your Business Powered During Unexpected Outages"}
        subHeading={""}
        text={`Unexpected power outages can disrupt business operations, damage equipment, and cause costly downtime. TRU Electrical Services installs commercial backup power systems, including automatic transfer switches (ATS), backup generator connections, commercial electrical distribution systems, switchgear, and energy-efficient lighting controls. As part of our Caledon electrical services, we also provide prompt electrical repairs and emergency electrical services when urgent issues arise. Every installation and repair is completed to meet current ESA requirements and electrical safety standards.`}
        img={"/images/backup-power-eg4-12000xp-on-battery.jpg"}
        cta={true}
        imgBorderRad={true}
      />
      <AboutSec
        heading={"ESA-Certified Electrical Work in Caledon"}
        subHeading={"Licensed & Compliant"}
        text={`Electrical work should always be completed by qualified professionals. As a licensed electrician Caledon property owners can depend on, TRU Electrical Services performs every project in accordance with the requirements of the Electrical Safety Authority (ESA). From residential electrical upgrades and commercial installations to solar electrical permitting and renewable energy projects, we manage the required ESA notifications, inspections, and approvals. Whether you're upgrading your home's electrical system or completing a large commercial project, our experienced team delivers safe, reliable workmanship with careful attention to quality and code compliance.`}
        img={"/images/esa-certified-work-eg4-12000xp-and-conduit.jpg"}
        reverse={true}
        cta={true}
        imgBorderRad={true}
      />


    <div
        style={{ padding: "80px 0px 80px 0px" }}
        className="main text-center"
      >
        <Container>
          <Row className="gy-4 gx-5">
            <Col lg={6}>
              <div className={formstyles.contentCol}>
                <h3 className="h2_main pb-2">Contact us</h3>
                <h2 className="h1_main pb-4">
                  Talk to Us About Your Residential or Commercial  <span>Electrical Project.</span>
                </h2>
                <Row>
                  <Col className="pt-3" lg={12}>
                    <a
                      style={{ textDecoration: "none" }}
                      href="tel: 905-299-7841"
                    >
                      <div className={formstyles.info}>
                        <img src="/images/phone.svg" alt="icon" />
                        <p className="para_main">905-299-7841</p>
                      </div>
                    </a>
                  </Col>
                  <Col className="pt-3" lg={12}>
                    <a
                      style={{ textDecoration: "none" }}
                      href="mailto: sales@truoffgrid.com"
                    >
                      <div className={formstyles.info}>
                        <img src="/images/mail.svg" alt="icon" />
                        <p className="para_main">sales@truoffgrid.com</p>
                      </div>
                    </a>
                  </Col>
                  <Col className="pt-3" lg={12}>
                    <a
                      style={{ textDecoration: "none" }}
                      target="no_blank"
                      href="https://www.google.com/maps/dir//TRU+Off+Grid+-+Solar+%26+Energy+Storage,+348+Bronte+St.+S+Unit+21,+Milton,+ON+L9T+5B6/@43.5108146,-79.963851,12z/data=!4m8!4m7!1m0!1m5!1m1!1s0x267e0b12cb8a4ddf:0xae5c0834e6f5863a!2m2!1d-79.8791121!2d43.4996211?entry=ttu&g_ep=EgoyMDI2MTAxMy4wIKXMDSoASAFQAw%3D%3D"
                    >
                      <div className={formstyles.info}>
                        <img src="/images/location.svg" 
alt="icon"/>
                        <p className="para_main">
                          348 Bronte St., South Unit #21 Milton, ON (Please give
                          us a call, send an email or complete the Let's Get in
                          Touch form. Thanks)
                        </p>
                      </div>
                    </a>
                  </Col>
                </Row>
              </div>
            </Col>
            
            <Col lg={6}>
              <div className={formstyles.formCol}>
                <h2 className="h1_main pb-2">Let’s get in touch!</h2>
                <p className="para_main pb-5">
                  Let's discuss your project and find out how we can help.
                </p>
                {loading ? (
                  <div className="row pb-4">
                    <div className="col-12">
                      <Spinner
                        animation="border"
                        role="status"
                        style={{ color: "black" }}
                      />
                    </div>
                  </div>
                ) : success ? (
                  <div className="row pb-4">
                    <div className="col-12">
                      <p className="para_main" style={{ color: "black" }}>
                        {success}
                      </p>
                    </div>
                  </div>
                ) : (
                  error && (
                    <div className="row pb-4">
                      <div className="col-12">
                        <p className="para_main" style={{ color: "black" }}>
                          {error}
                        </p>
                      </div>
                    </div>
                  )
                )}
                <form onSubmit={formSubmitHandler}>
                  <input
                    maxLength="12"
                    type="text"
                    placeholder="Your Full Name"
                    pattern=".{3,}"
                    required
                    value={name}
                    onChange={(event) => setName(event.target.value)}
                  />
                  <input
                    maxLength="36"
                    type="email"
                    placeholder="Email"
                    pattern=".{3,}"
                    required
                    value={email}
                    onChange={(event) => setEmail(event.target.value)}
                  />
                  <input
                    maxLength="36"
                    type="text"
                    placeholder="Phone Number"
                    pattern=".{3,}"
                    required
                    value={phoneNum}
                    onChange={(event) => setPhoneNum(event.target.value)}
                  />
                  <input
                    style={{ resize: "none" }}
                    as="textarea"
                    maxLength="800"
                    type="text"
                    placeholder="Your Message"
                    required
                    value={message}
                    onChange={(event) => setMessage(event.target.value)}
                  />
                  <button className="button_main mt-3" type="submit">
                    Submit
                  </button>
                </form>
              </div>
            </Col>
          </Row>
        </Container>
      </div>

      
        <div className="py-5 my-4"></div>
      <Footer newsletter={true} introContent="TRU Off Grid delivers electrical, solar, and energy storage services for homes and businesses across Ontario. As a trusted provider of electrician services in Caledon, we install electrical systems, backup power solutions, battery storage, and solar equipment that meet current ESA requirements and industry safety standards." />
    </>
  );
};

export default Caledon;
